import {makeDateOptions} from '@freckle/educator-entities/ts/common/helpers/date-options'
import {useAsync} from '@freckle/educator-entities/ts/common/hooks/use-async'
import {useCourseMemberships} from '@freckle/educator-entities/ts/common/hooks/use-course-memberships'
import {
  isMathPremium as isMathPremiumF,
  isElaPremium as isElaPremiumF,
} from '@freckle/educator-entities/ts/common/logic/premium-access'
import {fetchCoursesStudentGoals} from '@freckle/educator-entities/ts/common/models/student-goal'
import {getStudentsforCourse} from '@freckle/educator-entities/ts/users/logic/students'
import {WithResources} from '@freckle/classroom/ts/common/components/with-resources'
import {useCurrentCourseId} from '@freckle/classroom/ts/hooks/use-current-course-id'
import {useQueryParamAsDate} from '@freckle/classroom/ts/hooks/use-params'
import {usePremiumLicenses} from '@freckle/classroom/ts/hooks/use-premium-licenses'
import {useStudents} from '@freckle/classroom/ts/hooks/use-students'
import {StudentGoalsContainer} from './student-goals'

export default function StudentGoalsHandler() {
  const {from: mFrom, to: mTo, dateOption: mDateOption} = useQueryParamAsDate()
  const students = useStudents()
  const courseMemberships = useCourseMemberships()
  const premiumLicenses = usePremiumLicenses()
  const {dateOption, from, to} = makeDateOptions(mDateOption, mFrom, mTo)
  const currentCourseId = useCurrentCourseId()
  const goals = useAsync(
    () => fetchCoursesStudentGoals(currentCourseId, from, to),
    'fetchCoursesStudentGoals',
    [currentCourseId, from, to],
  )

  return (
    <WithResources
      resources={{premiumLicenses, students, courseMemberships, goals}}
      render={({premiumLicenses, students, courseMemberships, goals}) => {
        const isMathPremium = isMathPremiumF(premiumLicenses)
        const isElaPremium = isElaPremiumF(premiumLicenses)
        return (
          <StudentGoalsContainer
            goals={goals}
            students={getStudentsforCourse(students, currentCourseId, courseMemberships)}
            isPremium={isMathPremium || isElaPremium}
            selectedDateOption={dateOption}
            from={from}
            to={to}
          />
        )
      }}
    />
  )
}
